import { constructionSafety, logisticsAsset, logisticsSafety, manufacturingAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Trong những năm gần đây, công nghệ UWB (Ultra-Wideband - Băng thông siêu rộng) RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang nhanh chóng thu hút sự chú ý trong nhiều lĩnh vực công nghiệp.',
  keywords: 'UWB, RTLS, bản sao số, chuyển đổi số, UWB, RTLS, ban sao so, chuyen doi so.',
  ogSite: 'UWB RTLS, sự khởi đầu cho các ngành công nghiệp của tương lai',
  title: 'UWB RTLS, sự khởi đầu cho các ngành công nghiệp của tương lai',
  ogUrl: 'https://orbro.io/vi/blog/uwbRtls',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDyMvH9u0-21RYnyyBVVc9guqVzCzv-ggtVgPCRQTLkEU33FS2rG9s1BImAzHdqx3slOcbgGEGcFnTwDAmmi0nBR-jQfAdavlymzwvoyWDbTWljNw2DPoaW_qaO4ciYcfvrO7YnaeT_zAYoHLLULjh7MSKToInBek_3WIXpnTfHBz83o4ryfNamREq7rU9e4ET1GsYzLjQ-33tSLxqcb1f1RUYR4qlgVm7ntqiwd4jyEZlj-33EJPgyvj3R-QwTvkFl1Ha2Z1oL3YBwdk33ugYt5wzdW-3IJa9T1gM6FWZbPZdnGWL0xDRYYzh0OTD7sckAN2dXqBwWWAqEjdyTKN6AfoQibnezcJUsWa12l8mton2PeSWa45J0NarK5Vrkbc_qrQzoC9iJ209QlewQrjmeCzUN2E9gIK8_O_eQ_seXYgBf-nQWy5BD5fX2goEJBEYQECwdmfhmRPWwkbQC8rXsKBhnXCZ9t3t65Dpn7Voj_tUI2w0wMMlJcsEpEpUdsd4hx6FrX5t4pHmpaJzEB5DxjLofbzSQXqEQcEQvkocvpBQ6HI9XVC5MFlwkonW-DUk_EwFlNGoCZYnZFFQjU-pK07aYDuZA4uvClTrr2OrxvC6iX2rVhJ01oGwN071DybCKXVsScEP4pQyzVkgMsbrOwoLXWRnDA5bl7_-nz4w1_PYbHs7kCJu14Zw1jaBhCb3vgIyFJPMHGaFGLUdtv00ej-qe1NVeGs5SGo8qkMOrkmAVxHx7cqR1ZqqeTvVy6xGAFPhJGvdZRlOV6T1M9HJ3a25z1couxxGM4TnjUSFrKXfhe--PNrqZxiX-4Yia8psajdHdqgD4I4KT6ryESC2umjrIiEI7oQyok08ry7UKuswV2OlxgJXmJYFOr6hBvriet1T1K8N7sko5tDVIDEyoVyGkGasOAifm6XgUZO3cbNLmvYib5LoKMKDFyldZpUxLWQ2yiI0ux0k-c303GbZ8h5nw-OP8JQekoR5do0QHpENpLqonOuBwnQZiBGmH2BGHHTYXGDNIl5s3QYqmWKNRQUMMvAau7nPXgQvmvJs3xRpcmPKFy1x149cg4cTWVvIL99qqF8lfTu8Dr0r2ycGSIm0NDz6WsrMA6cUDNEWZLdCFxEZMl6T7U2IFXBW0CLDmJ9UONldp_cQHYA-aIojbGabali2Q3YgwAKBlxyIytx5azfiIrUy3w7YzUE8BGiWS9faNVbZqk7TfUxA0mevS00orIB7fBajjFpHnkRPXLsXlm0d6pZTBHMzyu1s77gT-82xJSJVvvkHA3SwtYpap0571i6g8VCzO_OkwDlxeQkY9P_BbcVYzEUxoeIrASHDZuuhT2rkJ1qOY0UbdZlGS5KOOO6R10Wi0z8p-SXJQRT9kOR1N2mhdGk_Z_rag_ptC5lHxc7dYZaT2NCqxEVI-GZa3fHcvyge6Gu0OzWP0o2N8x_8XpdTaJuMTcUd-vUlQdg-o1YKkmcoqzVjfZVLzqDF7tsS3KS7hO8cTL23IfERiTLhbOxtCkJTdtHTXhXVrgakFVdWBWUlxMxDP_Yyk12v-Dozi2pwBSbMdRIEJ1xvD4akO3=w2000-h1596',
  ogType: 'website',
  date: '2023-11-03',
  tag1: '#Uwb',
  tag2: '#Rtls',
  tag3: '#Bansaoso',
  tag4: '#Chuyendoiso',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong những năm gần đây, công nghệ UWB (Ultra-Wideband - Băng thông siêu rộng) RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang nhanh chóng thu hút sự chú ý trong nhiều lĩnh vực công nghiệp. Công nghệ này mang lại những thay đổi mang tính cách mạng trong lĩnh vực theo dõi vị trí và các dịch vụ dựa trên vị trí, và được kỳ vọng sẽ trở thành một giải pháp cho tương lai. Bài viết này sẽ tìm hiểu về công nghệ UWB RTLS là gì, các lĩnh vực ứng dụng và ưu điểm tiềm năng của nó, cũng như cách nó có thể phát triển hơn nữa trong tương lai.',
      dot: '',
    },
    {
      head: 'UWB RTLS là gì?',
      subHead: '',
      desc: 'UWB RTLS là một hệ thống theo dõi vị trí thời gian thực, sử dụng công nghệ UWB để cung cấp dữ liệu vị trí chính xác. UWB truyền dữ liệu bằng cách sử dụng băng thông tần số siêu rộng, qua đó có thể thu được thông tin vị trí cực kỳ chính xác. So với các hệ thống theo dõi vị trí hiện có như GPS hay Wi-Fi, công nghệ này cung cấp độ chính xác và khả năng hoạt động theo thời gian thực cao hơn nhiều.',
      dot: '',
    },
    {
      head: 'Lĩnh vực ứng dụng',
      subHead: 'Xây dựng và Kiến trúc',
      desc: 'Tại các công trường xây dựng, có thể theo dõi vị trí của tòa nhà, thiết bị và vật liệu để tối ưu hóa lịch trình làm việc và tăng cường an toàn. Ngoài ra, thông qua độ chính xác vị trí trong nhà, có thể triển khai các hệ thống tòa nhà thông minh.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân phối và Bán lẻ',
      desc: 'Các doanh nghiệp phân phối và bán lẻ có thể xác định vị trí sản phẩm và hàng tồn kho theo thời gian thực để cải thiện dịch vụ khách hàng và quản lý hàng tồn kho. Hơn nữa, có thể tối ưu hóa việc sắp xếp sản phẩm bằng cách phân tích hành vi mua hàng của khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giao thông và Quản lý lãnh thổ',
      desc: 'Trong mạng lưới đường bộ và đường sắt, có thể theo dõi vị trí của phương tiện, tàu hỏa và các phương tiện giao thông khác để quản lý tắc nghẽn giao thông và phòng ngừa tai nạn. Các cơ quan quản lý lãnh thổ có thể quản lý dữ liệu vị trí địa hình và tài nguyên để phân bổ tài nguyên một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'An ninh và Quản lý an toàn',
      desc: 'Tại các cơ sở quan trọng, sự kiện hoặc các cuộc tụ họp quy mô lớn, có thể sử dụng UWB RTLS để theo dõi vị trí của người và vật thể nhằm tăng cường an ninh và an toàn. Điều này cho phép phản ứng nhanh trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thể thao và Giải trí',
      desc: 'Tại các sân vận động thể thao hoặc nhà hát, có thể theo dõi vị trí của khán giả để tối ưu hóa việc tổ chức sự kiện và cung cấp dịch vụ hướng dẫn. Ngoài ra, có thể xác định chính xác vị trí của thiết bị máy quay và ánh sáng cho việc sản xuất truyền thông.',
      dot: '',
    },
    {
      head: 'Ưu điểm',
      subHead: 'Độ chính xác cao',
      desc: 'Công nghệ UWB cung cấp độ chính xác cao hơn nhiều so với các công nghệ không dây khác. Dựa trên việc đo khoảng cách giữa các cảm biến, có thể thu được dữ liệu vị trí chính xác cả trong nhà và ngoài trời.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Độ trễ thấp',
      desc: 'UWB cung cấp thời gian phản hồi nhanh, cho phép thu thập thông tin vị trí thời gian thực một cách nhanh chóng. Điều này nâng cao khả năng phản ứng nhanh của hệ thống và tính hữu dụng trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hỗ trợ đa người dùng',
      desc: 'UWB có thể theo dõi đồng thời nhiều người dùng hoặc vật thể, điều này rất quan trọng trong các sự kiện quy mô lớn hoặc môi trường công nghiệp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'An toàn và Bảo mật',
      desc: 'UWB giảm thiểu nhiễu với các công nghệ truyền thông không dây khác và cung cấp mức độ bảo mật cao. Điều này đảm bảo an toàn cho dữ liệu và hệ thống nhạy cảm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng dụng trong nhà và ngoài trời',
      desc: 'UWB RTLS có thể được sử dụng cả trong nhà và ngoài trời, điều này có nghĩa là nó có tính linh hoạt cao trong nhiều lĩnh vực công nghiệp khác nhau.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hoạt động tiêu thụ điện năng thấp',
      desc: 'Công nghệ UWB hỗ trợ truyền thông không dây tiêu thụ điện năng thấp, do đó có thể kéo dài tuổi thọ pin và nâng cao hiệu quả sử dụng năng lượng.',
      dot: '',
    },
    {
      head: 'Triển vọng tương lai',
      subHead: '',
      desc: 'Công nghệ UWB RTLS được dự báo sẽ đóng một vai trò ngày càng quan trọng hơn trong tương lai. Trong tương lai, sẽ có nhiều thiết bị và hệ thống hơn nữa sử dụng UWB để kết nối với nhau, và công nghệ UWB RTLS sẽ được áp dụng trong các thành phố thông minh, nhà máy thông minh, xe tự hành, lĩnh vực y tế và nhiều lĩnh vực đa dạng khác. Thông qua đó, dự kiến sẽ đạt được những cải thiện về năng suất, tăng cường an toàn, cải thiện môi trường và nâng cao sự tiện lợi.\nTóm lại, UWB RTLS đang thu hút sự chú ý như một trong những công nghệ sẽ trở thành giải pháp của tương lai. Xét đến tính ổn định, độ chính xác và khả năng ứng dụng trong nhiều lĩnh vực công nghiệp khác nhau, công nghệ này được kỳ vọng sẽ có những tác động tích cực đến đời sống hàng ngày của chúng ta và các ngành công nghiệp đa dạng. Thông qua sự phát triển và lan tỏa của công nghệ này, tương lai sẽ trở thành một thế giới thông minh và hiệu quả hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
